/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_TimeInputs */

const en_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match by Time`)
};

const fr_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match par heure`)
};

const de_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiel nach Zeit`)
};

const it_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partita per tempo`)
};

const ru_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матч по времени`)
};

const es_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencia por tiempo`)
};

const zh_cn2_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间匹配`)
};

const ja_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間による試合`)
};

const hi_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय के अनुसार मैच`)
};

const pt_pt2_metadata_merge_match_by_time = /** @type {(inputs: Metadata_Merge_Match_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondência por tempo`)
};

/**
* | output |
* | --- |
* | "Match by Time" |
*
* @param {Metadata_Merge_Match_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_time = /** @type {((inputs?: Metadata_Merge_Match_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_match_by_time(inputs)
	if (locale === "de") return de_metadata_merge_match_by_time(inputs)
	if (locale === "it") return it_metadata_merge_match_by_time(inputs)
	if (locale === "ru") return ru_metadata_merge_match_by_time(inputs)
	if (locale === "es") return es_metadata_merge_match_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_match_by_time(inputs)
	if (locale === "ja") return ja_metadata_merge_match_by_time(inputs)
	if (locale === "hi") return hi_metadata_merge_match_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_match_by_time(inputs)
	return en_metadata_merge_match_by_time(inputs)
});